<template>
    <div class="noContent">
        <img src="~@img/xueyezixun/public/no_content.png" alt="">
    </div>
</template>

<script>
export default {
    name: "noContent",
    props: {
        type: {
            type: String,
            default: 'btnBlue'
        },
        name: String,
    },
    methods: {
        handleClick(){
            this.$emit('handleClick')
        }

    }

}
</script>

<style scoped lang="less">
.noContent {
    img {
        display: block;
        margin: 0 auto;
    }
}
</style>